import React from 'react';

import { Container } from './styles';

const Home: React.FC = () => {
  return <Container />;
};

export default Home;
